import React from 'react'
import Card from '../HeadingComponent/Card/Card'
import classes from './SubjectHeading.module.css'
import image from '../../../Assests/Image/audio_book.png'
import image2 from '../../../Assests/Image/right_to_education.png'
const SubjectHeading = (props)=>{
    const heading = props.SubjectHeadingData.subject_name
    const contents = props.contents.toString()
    return(
        <div className={classes.container}>
            <p className={classes.heading}>{heading}</p>
            <p className={classes.content}> Your Complete Study material  is Available here as per the University Syllabus</p>
            <p className={classes.content}>Study Material Contains: {contents}</p>
            <div className={classes.cards}>
            <Card heading ="What will You learn"  content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. " image={image}/>
            <Card heading="Uses of Your Career" content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. " image={image2}/>
        </div>
        </div>
        
    )
}
export default SubjectHeading